import { ILeadRepository } from '../../infrastructure/repositories'

export class CheckEmailUseCase {
 constructor(private leadRepository: ILeadRepository) {}

 async execute(email: string, currentLeadEmails?: string[]): Promise<{
 exists: boolean
 warning: string | null
 leadId?: string
 }> {
 if (!email || !email.trim()) {
 return { exists: false, warning: null }
 }

 const cleanEmail = email.trim().toLowerCase()
 const currentLeadHasEmail = currentLeadEmails?.some(
  (value) => value.trim().toLowerCase() === cleanEmail
 )

 if (currentLeadHasEmail) {
 return { exists: false, warning: null }
 }

 try {
 const result = await this.leadRepository.checkEmailExists(cleanEmail)
 if (result.exists && result.lead) {
 return {
 exists: true,
 warning: `⚠️ Este e-mail já está cadastrado para o cliente: ${result.lead.name || 'Desconhecido'}`,
 leadId: result.lead.id,
 }
 }
 return { exists: false, warning: null }
 } catch (error) {
 console.error('Erro ao verificar e-mail:', error)
 return { exists: false, warning: null }
 }
 }
}
